"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearOrders = exports.fetchOrdersFailure = exports.fetchOrdersSuccess = exports.fetchOrdersRequest = exports.ORDERS_CLEAR = exports.FETCH_ORDERS_FAILURE = exports.FETCH_ORDERS_SUCCESS = exports.FETCH_ORDERS_REQUEST = void 0;
exports.FETCH_ORDERS_REQUEST = 'orders/FETCH_ORDERS_REQUEST';
exports.FETCH_ORDERS_SUCCESS = 'orders/FETCH_ORDERS_SUCCESS';
exports.FETCH_ORDERS_FAILURE = 'orders/FETCH_ORDERS_FAILURE';
exports.ORDERS_CLEAR = 'orders/clear';
var fetchOrdersRequest = function () { return ({ type: exports.FETCH_ORDERS_REQUEST }); };
exports.fetchOrdersRequest = fetchOrdersRequest;
var fetchOrdersSuccess = function (data) { return ({ type: exports.FETCH_ORDERS_SUCCESS, data: data }); };
exports.fetchOrdersSuccess = fetchOrdersSuccess;
var fetchOrdersFailure = function (e) { return ({ type: exports.FETCH_ORDERS_FAILURE, e: e }); };
exports.fetchOrdersFailure = fetchOrdersFailure;
var clearOrders = function () { return ({ type: exports.FETCH_ORDERS_FAILURE }); };
exports.clearOrders = clearOrders;
